module.exports = __webpack_public_path__ + "static/media/promo_2.1e695e8a.jpg";